/**
 * VierBeinerGlück · 2-stufiges Upsell-Popup
 * ───────────────────────────────────────────────────────────────
 * Stufe 1 (Duo): fängt "In den Warenkorb" auf der PDP ab und bietet das
 *   passende Set an (Datenquelle: VBG_UPSELL_MAP via VBG_getMapping).
 * Stufe 2 (Trio): nach Annahme (Pfad A = Upgrade) ODER Ablehnung (Pfad B =
 *   Alternative) der Stufe 1, sofern ein passendes Trio gemappt ist.
 *
 * Tracking ausschließlich über versteckte Line-Item-Property `_upsell_source`.
 * Keine externen Libraries. Vanilla JS.
 */
(function () {
  'use strict';

  var CFG = window.VBG_UPSELL_CONFIG || {};
  var ASSETS = window.VBG_UPSELL_ASSETS || {};
  var MAP = window.VBG_UPSELL_MAP;
  var getMapping = window.VBG_getMapping;

  var overlay = document.getElementById('vbgUpsell');
  var form = document.getElementById('vbg-product-form');
  if (!overlay || !form || !MAP || typeof getMapping !== 'function') return;

  /* Saison-aufgelöstes Mapping für DIESES Produkt. Ohne Duo kein Popup. */
  var mapping;
  try { mapping = getMapping(CFG.handle, new Date()); } catch (e) { mapping = null; }
  if (!mapping || !mapping.duo) return;

  /* position:fixed-Overlay an <body> hängen — der PDP-Hero hat transform-Container,
     in denen fixed falsch positioniert würde (Klicks landen daneben). */
  if (overlay.parentNode !== document.body) document.body.appendChild(overlay);

  // ── Refs ────────────────────────────────────────────────────
  var el = {
    overlay:   overlay.querySelector('.vbg-upsell__overlay'),
    modal:     overlay.querySelector('.vbg-upsell__modal'),
    eyebrow:   document.getElementById('vbgUpsellEyebrow'),
    stage:     document.getElementById('vbgUpsellStage'),
    quote:     document.getElementById('vbgUpsellQuote'),
    title:     document.getElementById('vbgUpsellTitle'),
    was:       document.getElementById('vbgUpsellWas'),
    now:       document.getElementById('vbgUpsellNow'),
    saveAmt:   document.getElementById('vbgUpsellSaveAmt'),
    savePct:   document.getElementById('vbgUpsellSavePct'),
    benefits:  document.getElementById('vbgUpsellBenefits'),
    trigger:   document.getElementById('vbgUpsellTrigger'),
    cta:       document.getElementById('vbgUpsellCta'),
    replace:   overlay.querySelector('.vbg-upsell__replace-text'),
    timer:     document.getElementById('vbgUpsellTimer'),
    timerCount:document.getElementById('vbgUpsellTimerCount'),
    timerDay:  document.getElementById('vbgUpsellTimerDay'),
    dismiss:   document.getElementById('vbgUpsellDismiss')
  };

  var currentView = null;     // aktuelle Stufen-Beschreibung
  var addedSetKey = null;     // Cart-Line-Key des in Stufe 1 angenommenen Sets (für Entfernen in Pfad A)
  var busy = false;           // verhindert Doppelklicks während Cart-Requests

  // ── sessionStorage Flags ────────────────────────────────────
  function ssGet(k) { try { return sessionStorage.getItem(k) === '1'; } catch (e) { return false; } }
  function ssSet(k) { try { sessionStorage.setItem(k, '1'); } catch (e) {} }
  function duoShown()  { return ssGet('vbg_upsell_shown_' + CFG.handle); }
  function markDuo()   { ssSet('vbg_upsell_shown_' + CFG.handle); }
  function trioShown(setHandle) { return ssGet('vbg_upsell_trio_shown_' + setHandle); }
  function markTrio(setHandle)  { ssSet('vbg_upsell_trio_shown_' + setHandle); }

  // ── Produktdaten-Cache (Preload-Assets + Fetch-Fallback) ────
  var cache = {};
  Object.keys(ASSETS).forEach(function (h) { cache[h] = ASSETS[h]; });

  function sizedImg(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function firstVariant(p) {
    if (p && p.variants) {
      for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available) return p.variants[i].id; }
      if (p.variants[0]) return p.variants[0].id;
    }
    return null;
  }
  function getProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return null;
        var data = {
          title: p.title,
          img: sizedImg(p.featured_image || (p.images && p.images[0]), 600),
          url: p.url,
          available: p.available,
          vid: firstVariant(p),
          vt: (p.variants && p.variants[0] && p.variants[0].title) || ''
        };
        cache[handle] = data;
        return data;
      })
      .catch(function () { return null; });
  }

  // ── Hilfen für needed-handles / Prefetch ────────────────────
  function neededHandles() {
    var hs = [CFG.handle, mapping.duo.cross_sell_handle, mapping.duo.set_handle];
    if (mapping.trio) {
      hs = hs.concat(mapping.trio.contained_products || []);
      if (mapping.trio.additional_handle) hs.push(mapping.trio.additional_handle);
      if (mapping.trio.set_handle) hs.push(mapping.trio.set_handle);
    }
    return hs.filter(function (h, i) { return h && hs.indexOf(h) === i; });
  }
  (window.requestIdleCallback || function (cb) { return setTimeout(cb, 1200); })(function () {
    neededHandles().forEach(function (h) { getProduct(h); });
  });

  // ── Formatierung ────────────────────────────────────────────
  function eur(n)      { return '€' + Number(n).toFixed(2).replace('.', ','); }
  function eurSuffix(n){ return Number(n).toFixed(2).replace('.', ',') + ' €'; }

  // ── Cart-API ────────────────────────────────────────────────
  function cartAdd(id, source) {
    var body = { id: id, quantity: 1 };
    if (source) body.properties = { _upsell_source: source };
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function cartRemove(idOrKey) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: idOrKey, quantity: 0 })
    }).then(function (r) { return r.json(); });
  }
  function goCart() { window.location.href = '/cart'; }

  // ── Trio-Gültigkeit für einen Pfad ──────────────────────────
  function trioPossible() {
    var t = mapping.trio;
    if (!t || !t.set_handle) return false;
    if (trioShown(t.set_handle)) return false;
    var contained = t.contained_products || [];
    if (contained.indexOf(CFG.handle) === -1) return false;
    if (contained.indexOf(mapping.duo.cross_sell_handle) === -1) return false;
    var setA = cache[t.set_handle];
    if (setA && setA.available === false) return false; // OOS -> kein Trio
    return true;
  }

  // Metafeld-Lookup mit Mapping-Fallback (Spec §3 + correction-prompt §12).
  // Tagline + Benefits dürfen leer/nicht gepflegt sein → dann Mapping-Defaults nutzen.
  function metaTagline(setHandle, fallback) {
    var m = ASSETS[setHandle] || cache[setHandle];
    var t = m && m.tagline;
    return (t && String(t).trim()) ? t : fallback;
  }
  function metaBenefits(setHandle, fallback) {
    var m = ASSETS[setHandle] || cache[setHandle];
    var raw = m && m.why_items;
    if (!raw || !raw.length) return fallback;
    // Robust: Werte können je nach Metafield-Typ Strings ODER Objekte sein
    // (z.B. {value:"…"} bei einigen Metaobject-Definitionen). Wir extrahieren
    // den anzeigbaren Text und filtern Leeres raus.
    var clean = [];
    for (var i = 0; i < raw.length && clean.length < 3; i++) {
      var v = raw[i];
      var s = '';
      if (typeof v === 'string') s = v;
      else if (v && typeof v === 'object') s = v.value || v.text || v.label || '';
      s = String(s || '').trim();
      if (s) clean.push(s);
    }
    return clean.length ? clean : fallback;
  }

  // ── View-Builder ────────────────────────────────────────────
  function duoView() {
    var d = mapping.duo;
    return {
      stage: 1,
      eyebrow: 'SARIS LIEBLINGS-DUO FÜR DEINEN HUND',
      handles: [CFG.handle, d.cross_sell_handle],
      quote: metaTagline(d.set_handle, d.sari_quote),
      title: d.set_title,
      was: d.original_price, now: d.set_price,
      saveAmt: d.saving_amount, savePct: d.saving_percent,
      benefits: metaBenefits(d.set_handle, d.benefits),
      trigger: 'Gönne deinem Liebling die beste Pflege & Vorsorge!',
      ctaLabel: 'Set in den Warenkorb →',
      replace: 'Das Set ersetzt dein Einzelprodukt im Warenkorb',
      dismissLabel: 'Nein danke, weiter stöbern',
      onCta: acceptDuo,
      onDismiss: rejectDuo
    };
  }
  function trioViewA() {
    var t = mapping.trio;
    return {
      stage: 2,
      eyebrow: 'MÖCHTEST DU NOCH MEHR FÜR DEINEN LIEBLING TUN?',
      handles: (t.contained_products || []).concat(t.additional_handle ? [t.additional_handle] : []),
      quote: metaTagline(t.set_handle, t.sari_quote),
      title: t.set_title,
      was: t.original_price, now: t.set_price,
      saveAmt: t.saving_amount, savePct: t.saving_percent,
      benefits: metaBenefits(t.set_handle, t.benefits),
      trigger: 'Das Rundum-Wohlfühl-Paket für deinen Liebling!',
      ctaLabel: 'Trio in den Warenkorb →',
      replace: 'Das Trio ersetzt das Set in deinem Warenkorb',
      dismissLabel: 'Nein danke, ich behalte das Set',
      onCta: acceptTrioUpgrade,
      onDismiss: keepSet
    };
  }
  function trioViewB() {
    var t = mapping.trio;
    return {
      stage: 2,
      eyebrow: 'VIELLEICHT IST DAS DAS RICHTIGE FÜR EUCH',
      handles: (t.contained_products || []).concat(t.additional_handle ? [t.additional_handle] : []),
      quote: metaTagline(t.set_handle, t.sari_quote),
      title: t.set_title,
      was: t.original_price, now: t.set_price,
      saveAmt: t.saving_amount, savePct: t.saving_percent,
      benefits: metaBenefits(t.set_handle, t.benefits),
      trigger: 'Das Rundum-Wohlfühl-Paket für deinen Liebling!',
      ctaLabel: 'Trio in den Warenkorb →',
      replace: 'Das Trio ersetzt dein Einzelprodukt im Warenkorb',
      dismissLabel: 'Nein danke, nur das Einzelprodukt bestellen',
      onCta: acceptTrioDirect,
      onDismiss: takeSingle
    };
  }

  // ── Aktionen ────────────────────────────────────────────────
  function acceptDuo() {
    if (busy) return; busy = true; ctaLoading(true);
    getProduct(mapping.duo.set_handle).then(function (setData) {
      if (!setData || !setData.vid || setData.available === false) { busy = false; return takeSingle(); }
      return cartAdd(setData.vid, 'popup_stage1_duo').then(function (item) {
        addedSetKey = item && item.key ? item.key : null;
        if (trioPossible()) { markTrio(mapping.trio.set_handle); transitionTo(trioViewA()); } // busy bleibt true bis Stufenwechsel fertig
        else { goCart(); }
      });
    }).catch(function () { busy = false; goCart(); });
  }

  function rejectDuo() {
    if (busy) return; busy = true;
    if (trioPossible()) { markTrio(mapping.trio.set_handle); transitionTo(trioViewB()); return; } // busy bleibt true bis Stufenwechsel fertig
    cartAdd(CFG.baseVariantId).then(goCart).catch(goCart);
  }

  function acceptTrioUpgrade() {
    if (busy) return; busy = true; ctaLoading(true);
    getProduct(mapping.trio.set_handle).then(function (trioData) {
      if (!trioData || !trioData.vid) return goCart();
      var rem = addedSetKey ? cartRemove(addedSetKey) : Promise.resolve();
      return rem.then(function () { return cartAdd(trioData.vid, 'popup_stage2_trio_upgrade'); }).then(goCart);
    }).catch(goCart);
  }

  function keepSet() { if (busy) return; busy = true; goCart(); }

  function acceptTrioDirect() {
    if (busy) return; busy = true; ctaLoading(true);
    getProduct(mapping.trio.set_handle).then(function (trioData) {
      if (!trioData || !trioData.vid) return takeSingle();
      return cartAdd(trioData.vid, 'popup_stage2_trio_direct').then(goCart);
    }).catch(goCart);
  }

  function takeSingle() { if (busy) return; busy = true; cartAdd(CFG.baseVariantId).then(goCart).catch(goCart); }

  // ── Rendering ───────────────────────────────────────────────
  function ctaLoading(on) { el.cta.classList.toggle('is-loading', !!on); }

  function renderStage(handles) {
    el.stage.innerHTML = '';
    el.stage.setAttribute('data-count', handles.length);
    handles.forEach(function (h) {
      var slot = document.createElement('div');
      slot.className = 'vbg-upsell__slot';
      var fig = document.createElement('div');
      fig.className = 'vbg-upsell__product is-loading';
      var img = document.createElement('img');
      img.className = 'vbg-upsell__product-img';
      img.alt = '';
      img.decoding = 'async';
      img.addEventListener('load', function () { fig.classList.remove('is-loading'); });
      fig.appendChild(img);
      slot.appendChild(fig);
      var size = document.createElement('div');
      size.className = 'vbg-upsell__product-size';
      slot.appendChild(size);
      el.stage.appendChild(slot);
      getProduct(h).then(function (data) {
        if (data && data.img) { img.src = data.img; img.alt = data.title || ''; }
        else { fig.classList.remove('is-loading'); }
        var vt = (data && data.vt) ? String(data.vt).trim() : '';
        if (vt && vt.toLowerCase() !== 'default title') size.textContent = '1 × ' + vt;
      });
    });
  }

  function fillView(view) {
    currentView = view;
    overlay.setAttribute('data-stage', view.stage);
    el.eyebrow.textContent = view.eyebrow;
    el.quote.textContent = view.quote || '';
    el.title.textContent = view.title;
    el.was.textContent = eur(view.was);
    el.now.textContent = eur(view.now);
    el.saveAmt.textContent = eurSuffix(view.saveAmt);
    el.savePct.textContent = '−' + view.savePct + '%';

    el.benefits.innerHTML = '';
    (view.benefits || []).forEach(function (b) {
      // Defensive: nur Strings rendern, sonst zeigt textContent "[object Object]"
      var text = (typeof b === 'string') ? b : (b && (b.value || b.text || b.label)) || '';
      if (!text) return;
      var li = document.createElement('li');
      li.textContent = String(text);
      el.benefits.appendChild(li);
    });

    el.trigger.textContent = view.trigger;
    el.cta.textContent = view.ctaLabel;
    el.cta.classList.remove('is-loading');
    el.replace.textContent = view.replace;
    el.dismiss.textContent = view.dismissLabel;

    renderStage(view.handles);
  }

  // ── Öffnen / Stufenwechsel / Schließen ──────────────────────
  var lastFocus = null;
  function openWith(view) {
    fillView(view);
    lastFocus = document.activeElement;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('vbg-upsell-lock');
    // Scroll-Position auf TOP, damit Produktbühne auf Mobile direkt sichtbar ist
    // (correction-prompt §9). Nach DOM-Paint nochmal nachziehen, falls Layout
    // sich beim is-open-Transition noch verschiebt.
    el.modal.scrollTop = 0;
    requestAnimationFrame(function () { el.modal.scrollTop = 0; });
    startTimer();
    setTimeout(function () { el.cta.focus({ preventScroll: true }); }, 60);
  }

  function transitionTo(view) {
    el.modal.classList.add('is-switching');
    setTimeout(function () {
      fillView(view);
      busy = false; // Stufenwechsel abgeschlossen -> Buttons der neuen Stufe wieder aktiv
      el.modal.classList.remove('is-switching');
      // Stufenwechsel: neues Popup wieder oben starten
      el.modal.scrollTop = 0;
      requestAnimationFrame(function () { el.modal.scrollTop = 0; });
      setTimeout(function () { el.cta.focus({ preventScroll: true }); }, 60);
    }, 400);
  }

  // ── Trigger: Add-to-Cart abfangen ───────────────────────────
  var allowNative = false;
  var triggering = false;
  form.addEventListener('submit', function (e) {
    if (allowNative) return;                              // gewollter nativer Submit
    if (triggering) { e.preventDefault(); return; }       // Doppelklick während Cart-Check abfangen
    try {
      if (duoShown()) return;                             // diese Session schon gezeigt -> normal
      var input = form.querySelector('.vbg-variant-input');
      var selVid = input ? String(input.value) : '';
      if (!selVid || selVid !== String(CFG.baseVariantId)) return; // Multipack/keine Basismenge -> normal
    } catch (err) { return; }                             // Fehler -> normaler Add-to-Cart

    e.preventDefault();
    triggering = true;
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.classList.add('is-loading');

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.item_count > 0) return native(btn);     // Korb nicht leer -> normal
        return Promise.all([
          getProduct(mapping.duo.set_handle),
          getProduct(mapping.duo.cross_sell_handle)
        ]).then(function (res) {
          var setData = res[0], cs = res[1];
          if (!setData || setData.available === false || (cs && cs.available === false)) return native(btn);
          if (btn) btn.classList.remove('is-loading');
          markDuo();
          openWith(duoView());
        });
      })
      .catch(function () { native(btn); });
  });

  function native(btn) { if (btn) btn.classList.remove('is-loading'); allowNative = true; form.submit(); }

  // ── Interaktion (Dismiss = "Nein danke", identisch für X/Overlay/ESC/Link) ──
  function dismiss() { if (currentView && currentView.onDismiss) currentView.onDismiss(); }

  overlay.addEventListener('click', function (e) {
    if (e.target.closest('#vbgUpsellCta')) { if (currentView && currentView.onCta) currentView.onCta(); return; }
    if (e.target.closest('[data-vbg-dismiss]')) { dismiss(); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (!overlay.classList.contains('is-open')) return;
    if (e.key === 'Escape') { dismiss(); return; }
    if (e.key === 'Tab') trapTab(e);
  });

  // ── Fokus-Trap ──────────────────────────────────────────────
  function focusables() {
    return Array.prototype.slice.call(
      el.modal.querySelectorAll('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])')
    ).filter(function (n) { return n.offsetParent !== null; });
  }
  function trapTab(e) {
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  // ── Live-Express-Timer (Berlin-Zeit, identische Fenster wie PDP-Hero) ──
  var timerInterval = null;
  function berlinNow() { return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' })); }
  function updateTimer() {
    var now = berlinNow();
    var dow = now.getDay();                 // 0=So … 6=Sa
    var mins = now.getHours() * 60 + now.getMinutes();
    var WEEKDAY = 14 * 60 + 30, SAT = 12 * 60;
    var target, word;
    if (dow >= 1 && dow <= 5 && mins < WEEKDAY) {
      target = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 14, 30, 0, 0); word = 'heute';
    } else if (dow === 6 && mins < SAT) {
      target = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 12, 0, 0, 0); word = 'heute';
    } else {
      target = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
      word = (dow === 6 || dow === 0) ? 'Montag' : 'morgen';
    }
    var delta = Math.max(0, Math.floor((target - now) / 1000));
    el.timerCount.textContent = Math.floor(delta / 3600) + ' Std. ' + Math.floor((delta % 3600) / 60) + ' Min.';
    el.timerDay.textContent = word;
  }
  function startTimer() {
    if (!el.timer) return;
    el.timer.hidden = false;
    updateTimer();
    if (!timerInterval) timerInterval = setInterval(updateTimer, 60000);
  }
})();
